export const isEmpty = (arr: any): boolean => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return true; // It's either not an array or empty
  }

  return arr.every(obj => Object.keys(obj).length === 0);
}